import React from "react";

import { useBooleanState } from "hooks";

import { SkipIntegrationConfirmationModal } from "./components";

function SkipIntegrationButton() {
  const [
    isConfirmationModalOpen,
    openConfirmationModal,
    closeConfirmationModal,
  ] = useBooleanState();

  return (
    <React.Fragment>
      <button
        type="button"
        onClick={openConfirmationModal}
        style={{
          color: "#2185D0",
          background: "transparent",
          border: "none",
          cursor: "pointer",
          height: "24px",
        }}
      >
        Skip Integration
      </button>

      {isConfirmationModalOpen && (
        <SkipIntegrationConfirmationModal onClose={closeConfirmationModal} />
      )}
    </React.Fragment>
  );
}

SkipIntegrationButton.propTypes = {};

SkipIntegrationButton.defaultProps = {};

export default SkipIntegrationButton;
